import "../../components/commerce/checkout/payment-step/PaymentStepForm.css";
import "../../components/store-locator/AutocompleteStoreLocator.css";
import "../../fonts.css";
import "../../SmartBanner.css";

export const GlobalCss = () => {
    return <></>;
};
